<template>
    <div class="wrapper">
        <div style="height: 100%">           
            <el-tabs style="height: 100%" type="card">
                <el-tab-pane  label="随访表单模板编辑" >

                    <!-- <div class="title">
                        <p>基本信息</p>
                    </div> -->
                    <!-- <div class="line"></div> -->
                    <div style="display:flex; flex-direction: column; width:100%; margin-top: 10px; min-width: 1000px">
                        <div style="width:100%;">
                            <el-form :inline="true" :model="templateForm"   :rules="templateRules" style="width:100%; margin-top: 10px">
                                <el-col :span="8" >
                                    <el-form-item label="模板名称（必填）"  prop="name">
                                        <el-autocomplete
                                            class="popInput"
                                            v-model="templateForm.name"
                                            placeholder="请输入模板名称"
                                            style="width:300px"
                                        ></el-autocomplete>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="内容描述"  prop="description">
                                        <el-autocomplete
                                            class="popInput"
                                            v-model="templateForm.description"
                                            placeholder="请输入描述文字"
                                            style="width:400px"
                                        ></el-autocomplete>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="备注" prop="note">
                                        <el-autocomplete
                                            class="popInput"
                                            v-model="templateForm.note"
                                            placeholder="请输入备注信息"
                                            style="width:300px"
                                        ></el-autocomplete>
                                    </el-form-item>
                                </el-col>
                            </el-form>
                        </div>

                        <div style="width:100%;">
                            <fm-making-form
                                style="height: 750px"
                                ref="makingform"
                                preview
                            >
                                <template slot="action">
                                    <!-- 自定义操作区域插槽 -->
                                    <el-button @click="showTempleteValue" type="text" icon="el-icon-upload">保存</el-button>
                                </template>
                            </fm-making-form>
                        </div>
                    </div>
                </el-tab-pane>
                <!-- <el-tab-pane :lazy="true" label="表单编辑器">高级编辑器</el-tab-pane> -->
            </el-tabs>

        </div>
        <el-dialog title="新增随访表单模板" :visible.sync="dialogVisible">
            <el-form :model="templateForm" :rules="templateRules" ref="templateForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="模板名称" prop="name" >
                    <el-input
                            placeholder="模板名称"
                            v-model="templateForm.name">
                    </el-input>
                </el-form-item>
                <el-form-item label="内容描述" prop="description" v-if="templateForm.description">
                    <el-input
                            placeholder="描述文字"
                            v-model="templateForm.description">
                    </el-input>
                </el-form-item>

                <el-form-item label="备注" prop="note" v-if="templateForm.note">
                    <el-input
                            placeholder="备注"
                            v-model="templateForm.note">
                    </el-input>
                </el-form-item>
            </el-form>

            <div class="title">
                <p>表单内容预览：</p>
            </div>
            <div class="myformMaking" style="width: 100%;background-color: #ffffff">
                <fm-generate-form
                        :data="jsonData"
                        :remote="remoteFuncs"
                        :value="values"
                        ref="generateForm">
                </fm-generate-form>
            </div>


            <div slot="footer" class="dialog-footer">
                <el-button @click="saveTempleteValue" type="primary"  class="foot-save-btn">保存</el-button>
               <!-- <el-button  @click="saveTempleteValue" type="primary"  class="foot-save-btn">保存</el-button>-->
            </div>
        </el-dialog>
    </div>
</template>

<script>
    // import 'form-making/dist/FormMaking.less'
    import gql from 'graphql-tag';
    export default {
        name: '',
        data() {
            return {
                // 表单数据，用于预览已设计的表单
                jsonData: {
                }, 
                values: {}, // 表单填写内容
                remoteFuncs: {
                    // 组件配置时配置的远端方法,保持和配置时输入的名称一致
                    func_test (resolve) {
                        // 模拟接口请求
                        setTimeout(() => {
                            const options = [
                                {id: '1', name: '1111'},
                                {id: '2', name: '2222'},
                                {id: '3', name: '3333'}
                            ]

                            // 获取到的值和标签可以通过配置页远端配置
                            // 值:id  标签：name
                            resolve(options) // 将后端获取的数据放入回调函数中
                        }, 2000)
                    },

                },
                templateRules:{
                    name: [
                        { required: true, message: '请输入模板名称', trigger: 'blur' },
                    ],
                },
                templateValue:"",
                dialogVisible:false,
                // 编辑模式下，接收的路由参数，包括id
                template:{},
                // 随访表单相关数据,用于提交后台API 参数
                templateForm:{
                    name: "",
                    type: "随访表单",
                    description: "",
                    from: "1", // 0:内置；1：自建
                    content: "", // 表单数据
                    note: ""
                },
                IsEdit:0, // NEW or EDIT               
            }
        },
        methods: {
            showTempleteValue(){
                this.jsonData = this.$refs.makingform.getJSON()
                this.dialogVisible = true;
            },

            addTemplate(){
                /* tslint:disable:no-string-literal */
                this.$refs['templateForm'].validate(async(valid)  => {
                    /* tslint:enable:no-string-literal */
                    console.log("addTemplate,valid:", valid);
                    if (valid) {
                        try {

                            this.templateForm.type = "随访表单";
                            let res = await this.$apollo.mutate({
                                mutation: gql`mutation ($name: String!, $type:String!,  $description: String, $from: String, $content: String!, $note: String) {
                                addFollowupTemplate(
                                    name: $name
                                    type: $type
                                    description: $description
                                    from: $from
                                    content: $content
                                    note: $note
                                )
                                }`,
                                variables: this.templateForm
                            });
                            this.$message({
                                message: "新增成功!",
                                type: "success"
                            });
                            this.dialogVisible = false;
                        }catch (e) {
                            console.log("addTemplate,error:", e);
                            this.$message.error("操作失败,请重试:" + e.message.split(":")[1]);
                            // this.$message.error("操作失败,请重试")
                            this.dialogVisible = false;
                        }
                    } else {
                        console.log("In addTemplate,validate failed")
                        return false;
                    }
                });
            },
            updateTemplate(){
                let keys = 'templateForm';
                this.$refs[keys].validate(async(valid)  => {
                    if (valid) {
                        try {
                            this.templateForm.id = this.template.id;
                            let res = await this.$apollo.mutate({
                                mutation: gql`mutation ($id: Int!,$name: String!, $type:String!,  $description: String, $from: String, $content: String!, $note: String) {
                                    modifyFollowupTemplate(
                                        id: $id
                                        name: $name
                                        type: $type
                                        description: $description
                                        from: $from
                                        content: $content
                                        note: $note
                                    )
                                }`,
                                variables: this.templateForm
                            });
                            this.$message({
                                message: "更新成功!",
                                type: "success"
                            });
                            this.dialogVisible = false;
                        }catch (e) {
                            this.$message.error(e.message.split(":")[1]);
                        }
                    } else {
                        console.log("In updateTemplate,validate failed")
                        return false;
                    }
                });
            },

            checkValidate(){
                if(!this.templateForm.name){
                    this.$message.error("请输入模板名称!")
                    return false
                }
                if(!this.templateForm.content){
                    this.$message.error("表单内容不能为空!")
                    return false
                }
                return true;
            },

            async saveTempleteValue(){
                const formJsonValue = this.$refs.makingform.getJSON()
                this.templateForm.content = JSON.stringify(formJsonValue)
                if(!this.checkValidate()){
                    return
                }
                console.log("In saveTempleteValue:", this.templateForm, this.IsEdit);
                if (this.IsEdit === 0){
                    this.addTemplate();
                }else if (this.IsEdit === 1){
                    this.updateTemplate();
                }
            },
            init(){
                // 跳转而来，带参数,编辑模式
                if (this.$route.params.template!==undefined){
                    this.template = this.$route.params.template;
                    this.templateForm.name = this.template.name;
                    this.templateForm.description = this.template.description;
                    this.templateForm.note = this.template.note;                    
                    // 解析表单参数
                    this.$refs.makingform.setJSON(JSON.parse(this.$route.params.template.content))
                    this.IsEdit = 1;
                    console.log("编辑模式，传入参数：", this.template);
                }else {
                    // 新建模式
                    this.IsEdit = 0;
                    console.log("新建模式");
                }
            },
        },
        mounted() {
            this.init();
        },
    }
</script>

<!--<style lang="less"  scoped>
    @import '../assets/style/FormMaking.less';
</style>-->
<style lang="less"  scoped>
    .el-tabs__content{
        height: 100%;
    }
    .wrapper {
        width: 100%;
        height: calc(100% - 40px);

        .title {
            display: flex;
            color: #4ea3c0;
            // height: 40px;
            line-height: 45px;
            i {
                text-indent: 50px;
                font-size: 30px;
            }
            p {
                text-indent: 10px;
                font-size: 18px;
            }
        }
        .line {
            width: 100%;
            height: 2px;
            background: #4ea3c0;
        }
        .popInput {
            width: 100%;
        }

        .item {
            margin-top: 20px;
        }

        .item-head {
            display: flex;
            height: 36px;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #55a9c6;

            .til {
                color: #47a2bf;
                padding-left: 5px;
                font-size: 14px;
                font-weight: bold;
            }

            .save-btn {
                width: 80px;
                height: 20px;
                color: #fff;
                border-radius: 5px;
                background-color: #47a2bf;
                text-align: center;
                line-height: 20px;
                font-size: 12px;
                cursor: pointer;
            }
        }

        .parameter-list {
            .list-item {
                padding-left: 5px;
                margin-top: 10px;

                .list-til {
                    display: inline-block;
                    width: 100px;
                    font-size: 14px;
                    font-weight: bold;
                }

                input {
                    width: 270px;
                    height: 30px;
                    border: 1px solid #bbb;
                    border-radius: 5px;
                    text-indent: 10px;
                    outline: none;
                }
            }
        }
    }
</style>
